import { render } from "./ErrorScreen.vue?vue&type=template&id=101f2de0"
import script from "./ErrorScreen.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&lang=js"

import "./ErrorScreen.vue?vue&type=style&index=0&id=101f2de0&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn});
